import { Component } from 'vue-property-decorator';
import BaseFilter from './BaseFilter';

@Component
export default class SelectFilterComponent extends BaseFilter {
}
